/*import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Share2,
  Zap,
  ArrowLeft,
  Trophy,
  Medal,
  Instagram,
  Youtube,
  Music2,
  Globe,
  Loader2,
} from 'lucide-react';

import { motion } from 'framer-motion';

import { db } from '../serices/firebase';
import {
  collection,
  query,
  where,
  getDocs,
  limit,
} from 'firebase/firestore';

import SponsorStrip from '../components/SponsorStrip';

const Nominee = () => {
  const { slug } = useParams();

  const [nominee, setNominee] = useState(null);
  const [loading, setLoading] = useState(true);

  // VOTING STATUS
  const votingDeadline = new Date('2026-05-25T23:59:59');
  //const votingClosed = new Date() > votingDeadline;
  const votingClosed = true;

  // SOCIAL ICONS
  const getSocialIcon = (url) => {
    if (!url) return null;

    const lowerUrl = url.toLowerCase();

    if (lowerUrl.includes('instagram.com')) {
      return <Instagram size={20} />;
    }

    if (lowerUrl.includes('tiktok.com')) {
      return <Music2 size={20} />;
    }

    if (
      lowerUrl.includes('youtube.com') ||
      lowerUrl.includes('youtu.be')
    ) {
      return <Youtube size={20} />;
    }

    return <Globe size={20} />;
  };

  // FETCH NOMINEE
  useEffect(() => {
    const fetchNominee = async () => {
      setLoading(true);

      try {
        const q = query(
          collection(db, 'nominations'),
          where('slug', '==', slug),
          limit(1)
        );

        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          setNominee({
            id: querySnapshot.docs[0].id,
            ...querySnapshot.docs[0].data(),
          });
        } else {
          console.log('No such nominee!');
        }
      } catch (error) {
        console.error('Error fetching nominee:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNominee();
  }, [slug]);

  // SHARE
  const handleShare = () => {
    if (navigator.share && nominee) {
      navigator.share({
        title: `Vote for ${nominee.name}`,
        url: window.location.href,
      });
    }
  };

  // LOADING
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2
          className="animate-spin text-[#D4AF37]"
          size={48}
        />
      </div>
    );
  }

  // NOT FOUND
  if (!nominee) {
    return (
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
        <h1 className="text-4xl font-black mb-4 uppercase">
          Nominee Not Found
        </h1>

        <Link
          to="/"
          className="text-[#D4AF37] underline tracking-widest uppercase text-xs"
        >
          Return Home
        </Link>
      </div>
    );
  }

  // FLOATING ANIMATION
  const floatingVariants = {
    animate: {
      y: [0, -20, 0],
      rotate: [0, 5, -5, 0],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  return (
    <div className="bg-black min-h-screen py-2 px-6 relative overflow-hidden font-sans">

      {/* BACKGROUND *//*
      <div className="absolute inset-0 pointer-events-none overflow-hidden -z-0">
        
        <motion.div
          variants={floatingVariants}
          animate="animate"
          className="absolute -top-10 -right-20 text-[#D4AF37]/10 blur-[2px]"
        >
          <Trophy
            size={400}
            strokeWidth={0.5}
          />
        </motion.div>

        <motion.div
          variants={floatingVariants}
          animate="animate"
          className="absolute -bottom-20 -left-20 text-[#D4AF37]/5 blur-[4px]"
          style={{ transitionDelay: '2s' }}
        >
          <Medal
            size={500}
            strokeWidth={0.3}
          />
        </motion.div>

        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-[150px]" />
      </div>

      {/* CONTENT *//*
      <div className="max-w-5xl mx-auto relative z-10">

        {/* BACK BUTTON *//*
        <Link
          to="/categories"
          className="inline-flex items-center gap-2 text-[10px] font-bold tracking-widest uppercase text-white/40 hover:text-[#D4AF37] mb-12 transition"
        >
          <ArrowLeft size={14} />
          Back to Categories
        </Link>

        <div className="flex flex-col md:flex-row gap-12 items-center">

          {/* IMAGE *//*
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            className="w-full md:w-1/2 relative group"
          >

            <div className="absolute -top-4 -left-4 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37] z-20" />

            <div className="absolute -bottom-4 -right-4 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37] z-20" />

            <img
              src={nominee.imageUrl}
              className="relative rounded-sm w-full aspect-[4/5] object-cover border border-white/10 shadow-2xl transition-all duration-700"
              alt={nominee.name}
            />
          </motion.div>

          {/* INFO *//*
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            className="w-full md:w-1/2"
          >

            <div className="flex items-center gap-3 mb-6">
              <div className="h-[1px] w-8 bg-[#D4AF37]" />

              <span className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.4em]">
                Official Nominee
              </span>
            </div>

            <h1 className="text-6xl font-black mb-2 tracking-tighter uppercase italic text-white leading-none">
              {nominee.name}
            </h1>

            <div className="text-[10px] font-bold tracking-[0.2em] text-[#D4AF37] uppercase mb-8">
              Category:{' '}
              <span className="text-white">
                {nominee.category}
              </span>
            </div>

            <p className="text-white/60 text-lg font-light leading-relaxed mb-10 italic border-l-2 border-[#D4AF37] pl-6">
              "{nominee.reason}"
            </p>

            {/* ACTIVE VOTING *//*
            {!votingClosed ? (
              <>
                {/* VOTES *//*
                <div className="bg-white/[0.03] backdrop-blur-md p-8 border border-white/10 mb-8 relative">
                  
                  <p className="text-[10px] text-white/40 uppercase tracking-widest mb-2 font-bold text-center">
                    Current Total Votes
                  </p>

                  <p className="text-5xl font-black text-[#D4AF37] text-center tracking-tighter">
                    {nominee.voteCount || 0}
                  </p>
                </div>

                {/* VOTE BUTTON *//*
                <Link to={`/vote-now/${nominee.id}`}>
                  
                  <button className="w-full bg-[#D4AF37] text-black py-6 font-black uppercase tracking-[0.3em] flex items-center justify-center gap-3 hover:bg-white transition duration-500 shadow-[0_0_40px_rgba(212,175,55,0.2)]">
                    
                    <Zap
                      fill="black"
                      size={18}
                    />

                    Vote for {nominee.name.split(' ')[0]}
                  </button>
                </Link>

                <p className="text-[8px] text-white/30 uppercase tracking-widest leading-relaxed mt-6 text-center">
                  By casting your vote, you agree to our{' '}
                  
                  <Link
                    to="/legal"
                    className="text-[#D4AF37] underline"
                  >
                    Terms of Service
                  </Link>

                  <br />

                  and acknowledge that this contribution is non-refundable.
                </p>
              </>
            ) : (
              // VOTING CLOSED
              <div className="bg-white/[0.03] backdrop-blur-md p-8 border border-[#D4AF37]/20 mb-8 text-center">

                <p className="text-[#D4AF37] text-[10px] uppercase tracking-[0.4em] font-black mb-4">
                  Voting Officially Closed
                </p>

                <h2 className="text-3xl font-black uppercase italic text-white mb-4">
                  Thank You For Your Support 🏆
                </h2>

                <p className="text-white/60 text-sm leading-relaxed mb-6">
                  Public voting for the Mzinyi Taita Taveta Awards Season 1
                  has officially ended.
                </p>

                <div className="space-y-2 text-sm text-white/70">
                  <p>📍 The Avid Hotel, Voi</p>
                  <p>📅 30th May 2026</p>
                  <p>🕔 5:00 PM – 11:00 PM</p>
                  <p>🎭 Dress Code: Black & Gold</p>
                  <p>🎟️ Free Entry</p>
                </div>
              </div>
            )}

            {/* SOCIALS *//*
            <div className="flex justify-center gap-6 mt-8">

              {nominee.socials?.instagram && (
                <a
                  href={nominee.socials.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/40 hover:text-[#D4AF37] transition"
                >
                  {getSocialIcon(nominee.socials.instagram)}
                </a>
              )}

              {nominee.socials?.tiktok && (
                <a
                  href={nominee.socials.tiktok}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/40 hover:text-[#D4AF37] transition"
                >
                  {getSocialIcon(nominee.socials.tiktok)}
                </a>
              )}

              {nominee.socials?.youtube && (
                <a
                  href={nominee.socials.youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/40 hover:text-[#D4AF37] transition"
                >
                  {getSocialIcon(nominee.socials.youtube)}
                </a>
              )}
            </div>

            {/* SHARE *//*
            <button
              onClick={handleShare}
              className="w-full mt-8 border border-white/10 text-white py-5 font-bold uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:bg-white/5 transition"
            >
              <Share2 size={16} />
              Share Profile
            </button>
          </motion.div>
        </div>

        {/* SPONSORS *//*
        <div className="max-w-7xl mx-auto pb-20">
          <SponsorStrip />
        </div>
      </div>
    </div>
  );
};

export default Nominee;*/











//latest code
/*
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Share2, Zap, ArrowLeft, Trophy, Medal, Award, Instagram, Youtube, Music2, Globe, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';
// 1. Import Firebase tools
import { db } from '../serices/firebase';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import SponsorStrip from '../components/SponsorStrip';

const Nominee = () => {
  // 2. We use 'slug' because that's what we defined in App.js (<Route path="/vote/:slug" ... />)
  const { slug } = useParams();
  const [nominee, setNominee] = useState(null);
  const [loading, setLoading] = useState(true);

  // 3. Helper to detect which social icon to show
  const getSocialIcon = (url) => {
    if (!url) return null;
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('instagram.com')) return <Instagram size={20} />;
    if (lowerUrl.includes('tiktok.com')) return <Music2 size={20} />;
    if (lowerUrl.includes('youtube.com') || lowerUrl.includes('youtu.be')) return <Youtube size={20} />;
    return <Globe size={20} />;
  };

  // 4. Fetch Nominee Data from Firestore
  useEffect(() => {
    const fetchNominee = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "nominations"), 
          where("slug", "==", slug),
          limit(1)
        );
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          setNominee({ id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() });
        } else {
          console.log("No such nominee!");
        }
      } catch (error) {
        console.error("Error fetching nominee:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNominee();
  }, [slug]);

  const handleShare = () => {
    if (navigator.share && nominee) {
      navigator.share({
        title: `Vote for ${nominee.name}`,
        url: window.location.href,
      });
    }
  };

  // 5. LOADING STATE
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="animate-spin text-[#D4AF37]" size={48} />
      </div>
    );
  }

  // 6. NOT FOUND STATE
  if (!nominee) {
    return (
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
        <h1 className="text-4xl font-black mb-4 uppercase">Nominee Not Found</h1>
        <Link to="/" className="text-[#D4AF37] underline tracking-widest uppercase text-xs">Return Home</Link>
      </div>
    );
  }

  const floatingVariants = {
    animate: {
      y: [0, -20, 0],
      rotate: [0, 5, -5, 0],
      transition: { duration: 6, repeat: Infinity, ease: "easeInOut" }
    }
  };

  return (
    <div className="bg-black min-h-screen py-2 px-6 relative overflow-hidden font-sans">
      
      {/* --- BACKGROUND DECORATIONS --- *//*
      <div className="absolute inset-0 pointer-events-none overflow-hidden -z-0">
        <motion.div variants={floatingVariants} animate="animate" className="absolute -top-10 -right-20 text-[#D4AF37]/10 blur-[2px]">
          <Trophy size={400} strokeWidth={0.5} />
        </motion.div>
        <motion.div variants={floatingVariants} animate="animate" className="absolute -bottom-20 -left-20 text-[#D4AF37]/5 blur-[4px]" style={{ transitionDelay: '2s' }}>
          <Medal size={500} strokeWidth={0.3} />
        </motion.div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-[150px]" />
      </div>

      {/* --- MAIN CONTENT --- *//*
      <div className="max-w-5xl mx-auto relative z-10">
        
        <Link to="/categories" className="inline-flex items-center gap-2 text-[10px] font-bold tracking-widest uppercase text-white/40 hover:text-[#D4AF37] mb-12 transition">
          <ArrowLeft size={14} /> Back to Categories
        </Link>

        <div className="flex flex-col md:flex-row gap-12 items-center">
          {/* Nominee Image *//*
          <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} className="w-full md:w-1/2 relative group">
             <div className="absolute -top-4 -left-4 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37] z-20" />
             <div className="absolute -bottom-4 -right-4 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37] z-20" />
             <img 
               src={nominee.imageUrl} 
               className="relative rounded-sm w-full aspect-[4/5] object-cover border border-white/10 shadow-2xl transition-all duration-700" 
               alt={nominee.name} 
             />
          </motion.div>

          {/* Info Section *//*
          <motion.div initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} className="w-full md:w-1/2">
            <div className="flex items-center gap-3 mb-6">
                <div className="h-[1px] w-8 bg-[#D4AF37]" />
                <span className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.4em]">Official Nominee</span>
            </div>
            
            <h1 className="text-6xl font-black mb-2 tracking-tighter uppercase italic text-white leading-none">
                {nominee.name}
            </h1>

            <div className="text-[10px] font-bold tracking-[0.2em] text-[#D4AF37] uppercase mb-8">
                Category: <span className="text-white">{nominee.category}</span>
            </div>

            <p className="text-white/60 text-lg font-light leading-relaxed mb-10 italic border-l-2 border-[#D4AF37] pl-6">
              "{nominee.reason}"
            </p>

            {/* Voting Stats *//*
            <div className="bg-white/[0.03] backdrop-blur-md p-8 border border-white/10 mb-8 relative">
              <p className="text-[10px] text-white/40 uppercase tracking-widest mb-2 font-bold text-center">Current Total Votes</p>
              <p className="text-5xl font-black text-[#D4AF37] text-center tracking-tighter">{nominee.voteCount || 0}</p>
            </div>

            {/* CTA Button - Links to the Payment/Vote page with the ID *//*
            <Link to={`/vote-now/${nominee.id}`}>
              <button className="w-full bg-[#D4AF37] text-black py-6 font-black uppercase tracking-[0.3em] flex items-center justify-center gap-3 hover:bg-white transition duration-500 shadow-[0_0_40px_rgba(212,175,55,0.2)]">
                <Zap fill="black" size={18} /> Vote for {nominee.name.split(' ')[0]}
              </button>
            </Link>

            <p className="text-[8px] text-white/30 uppercase tracking-widest leading-relaxed mt-6 text-center">
    By casting your vote, you agree to our <Link to="/legal" className="text-[#D4AF37] underline">Terms of Service</Link> <br/> 
    and acknowledge that this contribution is non-refundable.
</p>

            {/* Social Links Detection *//*
            <div className="flex justify-center gap-6 mt-8">
                {nominee.socials?.instagram && (
                    <a href={nominee.socials.instagram} target="_blank" rel="noreferrer" className="text-white/40 hover:text-[#D4AF37] transition">
                        {getSocialIcon(nominee.socials.instagram)}
                    </a>
                )}
                {nominee.socials?.tiktok && (
                    <a href={nominee.socials.tiktok} target="_blank" rel="noreferrer" className="text-white/40 hover:text-[#D4AF37] transition">
                        {getSocialIcon(nominee.socials.tiktok)}
                    </a>
                )}
                {nominee.socials?.youtube && (
                    <a href={nominee.socials.youtube} target="_blank" rel="noreferrer" className="text-white/40 hover:text-[#D4AF37] transition">
                        {getSocialIcon(nominee.socials.youtube)}
                    </a>
                )}
            </div>

            <button onClick={handleShare} className="w-full mt-8 border border-white/10 text-white py-5 font-bold uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:bg-white/5 transition">
              <Share2 size={16} /> Share Profile
            </button>
          </motion.div>
        </div>
        <div className="max-w-7xl mx-auto pb-20">
         <SponsorStrip />
      </div>
      </div>
    </div>
  );
};

export default Nominee;*/





import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
//import { Share2, Zap, ArrowLeft, Trophy, Medal, Award, Instagram, Youtube, Music2, Globe, Loader2 } from 'lucide-react';
import {
  Share2,
  Zap,
  ArrowLeft,
  Trophy,
  Medal,
  Loader2,
  Copy,
  Check
} from 'lucide-react';
import { motion } from 'framer-motion';
// 1. Import Firebase tools
import { db } from '../serices/firebase';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import SponsorStrip from '../components/SponsorStrip';
import { getEventPhase } from '../utils/eventDates';

const Nominee = () => {
  // 2. We use 'slug' because that's what we defined in App.js (<Route path="/vote/:slug" ... />)
  const { slug } = useParams();
  const [nominee, setNominee] = useState(null);
  const [loading, setLoading] = useState(true);
  const phase = getEventPhase();

  const [copied, setCopied] = useState(false);

  // 3. Helper to detect which social icon to show
  /*const getSocialIcon = (url) => {
    if (!url) return null;
    const lowerUrl = url.toLowerCase();
    if (lowerUrl.includes('instagram.com')) return <Instagram size={20} />;
    if (lowerUrl.includes('tiktok.com')) return <Music2 size={20} />;
    if (lowerUrl.includes('youtube.com') || lowerUrl.includes('youtu.be')) return <Youtube size={20} />;
    return <Globe size={20} />;
  };*/

  // 4. Fetch Nominee Data from Firestore
  useEffect(() => {
    const fetchNominee = async () => {
      setLoading(true);
      try {
        const q = query(
          collection(db, "nominations"), 
          where("slug", "==", slug),
          limit(1)
        );
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          setNominee({ id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() });
        } else {
          console.log("No such nominee!");
        }
      } catch (error) {
        console.error("Error fetching nominee:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNominee();
  }, [slug]);

  /*const handleShare = () => {
    if (navigator.share && nominee) {
      navigator.share({
        title: `Vote for ${nominee.name}`,
        url: window.location.href,
      });
    }
  };*/


  const handleShare = async () => {
  if (!nominee) return;

  const shareUrl = window.location.href;
  //const shareText = `Support ${nominee.name} in the Mzinyi Taita Taveta Awards 2026! Vote here: ${shareUrl}`;

  // Use the native share menu on supported mobile devices
  if (navigator.share) {
    try {
      await navigator.share({
        title: `Vote for ${nominee.name}`,
        text: `Support ${nominee.name} in the Mzinyi Taita Taveta Awards 2026!`,
        url: shareUrl,
      });
      return;
    } catch (error) {
      // Don't show an error if the user cancels sharing
      if (error.name === 'AbortError') return;
      console.error('Native sharing failed:', error);
    }
  }

  // Fallback: copy the link
  try {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  } catch (error) {
    // Clipboard fallback for browsers that block clipboard access
    window.prompt('Copy this nominee voting link:', shareUrl);
  }
};

  // 5. LOADING STATE
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="animate-spin text-[#D4AF37]" size={48} />
      </div>
    );
  }

  // 6. NOT FOUND STATE
  if (!nominee) {
    return (
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-6 text-center">
        <h1 className="text-4xl font-black mb-4 uppercase">Nominee Not Found</h1>
        <Link to="/" className="text-[#D4AF37] underline tracking-widest uppercase text-xs">Return Home</Link>
      </div>
    );
  }

  const floatingVariants = {
    animate: {
      y: [0, -20, 0],
      rotate: [0, 5, -5, 0],
      transition: { duration: 6, repeat: Infinity, ease: "easeInOut" }
    }
  };

  return (
    <div className="bg-black min-h-screen py-2 px-6 relative overflow-hidden font-sans">
      
      {/* --- BACKGROUND DECORATIONS --- */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden -z-0">
        <motion.div variants={floatingVariants} animate="animate" className="absolute -top-10 -right-20 text-[#D4AF37]/10 blur-[2px]">
          <Trophy size={400} strokeWidth={0.5} />
        </motion.div>
        <motion.div variants={floatingVariants} animate="animate" className="absolute -bottom-20 -left-20 text-[#D4AF37]/5 blur-[4px]" style={{ transitionDelay: '2s' }}>
          <Medal size={500} strokeWidth={0.3} />
        </motion.div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-[150px]" />
      </div>

      {/* --- MAIN CONTENT --- */}
      <div className="max-w-5xl mx-auto relative z-10">
        
        <Link to="/categories" className="inline-flex items-center gap-2 text-[10px] font-bold tracking-widest uppercase text-white/40 hover:text-[#D4AF37] mb-12 transition">
          <ArrowLeft size={14} /> Back to Categories
        </Link>

        <div className="flex flex-col md:flex-row gap-12 items-center">
          {/* Nominee Image */}
          <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} className="w-full md:w-1/2 relative group">
             <div className="absolute -top-4 -left-4 w-12 h-12 border-t-2 border-l-2 border-[#D4AF37] z-20" />
             <div className="absolute -bottom-4 -right-4 w-12 h-12 border-b-2 border-r-2 border-[#D4AF37] z-20" />
             <img 
               src={nominee.imageUrl} 
               className="relative rounded-sm w-full aspect-[4/5] object-cover border border-white/10 shadow-2xl transition-all duration-700" 
               alt={nominee.name} 
             />
          </motion.div>

          {/* Info Section */}
          <motion.div initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} className="w-full md:w-1/2">
            <div className="flex items-center gap-3 mb-6">
                <div className="h-[1px] w-8 bg-[#D4AF37]" />
                <span className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.4em]">Official Nominee</span>
            </div>
            
            <h1 className="text-6xl font-black mb-2 tracking-tighter uppercase italic text-white leading-none">
                {nominee.name}
            </h1>

            <div className="text-[10px] font-bold tracking-[0.2em] text-[#D4AF37] uppercase mb-8">
                Category: <span className="text-white">{nominee.category}</span>
            </div>

            <p className="text-white/60 text-lg font-light leading-relaxed mb-10 italic border-l-2 border-[#D4AF37] pl-6">
              "{nominee.reason}"
            </p>

            {/* Voting Stats */}
            <div className="bg-white/[0.03] backdrop-blur-md p-8 border border-white/10 mb-8 relative">
              <p className="text-[10px] text-white/40 uppercase tracking-widest mb-2 font-bold text-center">Current Total Votes</p>
              <p className="text-5xl font-black text-[#D4AF37] text-center tracking-tighter">{nominee.voteCount || 0}</p>
            </div>

            {/* CTA Button - Links to the Payment/Vote page with the ID, gated by event phase */}
            {phase === 'voting' ? (
              <Link to={`/vote-now/${nominee.id}`}>
                <button className="w-full bg-[#D4AF37] text-black py-6 font-black uppercase tracking-[0.3em] flex items-center justify-center gap-3 hover:bg-white transition duration-500 shadow-[0_0_40px_rgba(212,175,55,0.2)]">
                  <Zap fill="black" size={18} /> Vote for {nominee.name.split(' ')[0]}
                </button>
              </Link>
            ) : (
              <button disabled className="w-full bg-white/5 text-white/20 py-6 font-black uppercase tracking-[0.3em] flex items-center justify-center gap-3 cursor-not-allowed border border-white/5">
                {phase === 'nominating' ? 'Voting Opens Oct 26' : 'Voting Has Closed'}
              </button>
            )}

            <p className="text-[8px] text-white/30 uppercase tracking-widest leading-relaxed mt-6 text-center">
    By casting your vote, you agree to our <Link to="/legal" className="text-[#D4AF37] underline">Terms of Service</Link> <br/> 
    and acknowledge that this contribution is non-refundable.
</p>

            {/* Social Links Detection */}
            {/*<div className="flex justify-center gap-6 mt-8">
                {nominee.socials?.instagram && (
                    <a href={nominee.socials.instagram} target="_blank" rel="noreferrer" className="text-white/40 hover:text-[#D4AF37] transition">
                        {getSocialIcon(nominee.socials.instagram)}
                    </a>
                )}
                {nominee.socials?.tiktok && (
                    <a href={nominee.socials.tiktok} target="_blank" rel="noreferrer" className="text-white/40 hover:text-[#D4AF37] transition">
                        {getSocialIcon(nominee.socials.tiktok)}
                    </a>
                )}
                {nominee.socials?.youtube && (
                    <a href={nominee.socials.youtube} target="_blank" rel="noreferrer" className="text-white/40 hover:text-[#D4AF37] transition">
                        {getSocialIcon(nominee.socials.youtube)}
                    </a>
                )}
            </div>*/}

            {/*<button onClick={handleShare} className="w-full mt-8 border border-white/10 text-white py-5 font-bold uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:bg-white/5 transition">
              <Share2 size={16} /> Share Profile
            </button>*/}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-8">
  <button
    type="button"
    onClick={handleShare}
    className="w-full border border-white/10 text-white py-5 font-bold uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:bg-white/5 transition"
  >
    <Share2 size={16} />
    Share Profile
  </button>

  <button
    type="button"
    onClick={async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
      } catch {
        window.prompt('Copy this nominee voting link:', window.location.href);
      }
    }}
    className="w-full border border-[#D4AF37]/40 text-[#D4AF37] py-5 font-bold uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:bg-[#D4AF37]/10 transition"
  >
    {copied ? <Check size={16} /> : <Copy size={16} />}
    {copied ? 'Link Copied!' : 'Copy Link'}
  </button>
</div>
          </motion.div>
        </div>
        <div className="max-w-7xl mx-auto pb-20">
         <SponsorStrip />
      </div>
      </div>
    </div>
  );
};

export default Nominee;
